define([],function(){
    if(!String.prototype.contains && String.prototype.search) {
        String.prototype.contains = function(s) { return this.search(s) != -1; };
    }
    return {};
});